import { render, staticRenderFns } from "./stocks.vue?vue&type=template&id=5456cb32&"
import script from "./stocks.vue?vue&type=script&lang=js&"
export * from "./stocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports